var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Home extends Component {
    constructor() {
        super('Home', false);
        this.step = 1;
        this.texts = [];
        this.lastShape = null;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.module-home__text-source').each((element) => {
                this.texts.push($(element).html());
            });
            setTimeout(() => {
                this.animationStep();
            }, $(window).width() >= 992 ? 100 : 3000);
            this.success();
        });
    }
    animationStep() {
        if (this.lastShape) {
            this.lastShape.removeClass('bg-primary text-white').addClass('bg-white');
            const lastShape = this.lastShape;
            setTimeout(() => {
                lastShape.removeClass('align-items-center');
            }, 500);
        }
        const container = $(window).width() >= 992 ? $('.module-home__lg-content') : $('.module-home__xs-content');
        const lastActiveShape = container.find('.shape-can-contain-text.is-active').get(0);
        $('.shape-can-contain-text').addClass('shape--h-1').removeClass('is-active');
        // Select a random shape that is not the last active shape
        const shapes = Array.from(container.find('.shape-can-contain-text')).filter((shape) => shape !== lastActiveShape);
        const randomShape = shapes[Math.floor(Math.random() * shapes.length)];
        const index = this.step % this.texts.length;
        const textElement = $.parseHTML(`<div class="module-home__text p-32 p-lg-48 p-xxl-64 fs-larger h-fit">${this.texts[index]}</div>`);
        $(randomShape).empty().append(textElement).addClass('is-active').removeClass('shape--h-1');
        this.lastShape = $(randomShape);
        if (index === 1) {
            $(randomShape).removeClass('bg-white').addClass('bg-primary text-white align-items-center');
        }
        setTimeout(() => {
            this.animationStep();
        }, 5000);
        this.step++;
    }
}
